import React from 'react';
import { FadeIn } from './FadeIn';
import { trackPixelEvent } from '../lib/metaPixel';
export function PricingSection() {
  const includes = ['Guía completa de 21 días + capítulos extra', 'Protocolo de 21 días paso a paso', '3 fases progresivas de 21 días', 'Capítulo especial burnout maternal', 'Plan de mantenimiento más allá del día 21', 'Referencias científicas incluidas', 'Descarga inmediata en PDF'];
  return <section id="pricing" className="py-24 bg-white" data-id="element-116" data-mp="1naahj6l385wg">
      <div className="max-w-4xl mx-auto px-6" data-id="element-117" data-mp="1s8u7di2sy1u3">
        <FadeIn data-id="element-118" data-mp="1sbq5b6engqij">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal text-center mb-12" data-id="element-119" data-mp="1x8qcxlr5e1br">
            Tu inversión en
            <br data-id="element-120" data-mp="226rvm5knvymp" />
            paz mental hoy
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-121" data-mp="2uyv3yyo0b58">
          <div className="max-w-lg mx-auto bg-white rounded-3xl border-2 border-brand-forest shadow-2xl overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-122" data-mp="2vqod34shwsc">
            <div className="p-8 md:p-10 text-center border-b border-gray-100" data-id="element-123" data-mp="1mgeq5rsdfagr">
              <div className="text-brand-gray text-xl line-through decoration-brand-terracotta decoration-2 mb-2" data-id="element-124" data-mp="1hpy9lyt978q6">
                $27
              </div>
              <div className="text-6xl font-serif font-bold text-brand-forest mb-4" data-id="element-125" data-mp="1crn0jqas9290">
                $19.99
              </div>
              <div className="text-brand-charcoal font-medium" data-id="element-126" data-mp="17ppaod7vn973">
                Pago único — Descarga inmediata
              </div>
            </div>

            <div className="p-8 md:p-10 bg-brand-cream bg-opacity-30" data-id="element-127" data-mp="20g68u5tu1f13">
              <ul className="space-y-4 mb-8" data-id="element-128" data-mp="1vhcvqeigjq1g">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-3 text-brand-charcoal" data-id="element-129" data-mp="1rfrhopu6t5po" data-mpi={index}>
                    <span className="text-brand-sage flex-shrink-0" data-id="element-130" data-mp="k2zcjmynfyrr">✅</span>
                    <span className="font-medium" data-id="element-131" data-mp="g0cmnrljgnx7">{item}</span>
                  </li>)}
              </ul>

              <a href="https://pay.hotmart.com/P106181864L?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('AddToCart', {
              content_name: 'Desintoxica tu Mente en 21 Días',
              content_type: 'product',
              currency: 'USD',
              value: 19.99
            })} className="block text-center w-full bg-brand-terracotta text-white py-4 px-6 rounded-full text-lg font-bold hover:bg-opacity-90 hover:scale-[1.02] transition-all duration-300 shadow-lg mb-4" data-id="element-132" data-mp="hj2twpk4xrak">
                SÍ, QUIERO DESINTOXICAR MI MENTE — $19.99 →
              </a>

              <div className="text-center text-sm font-medium text-brand-charcoal mb-6" data-id="element-133" data-mp="3bxjx70qoxf9f">
                🔒 Pago 100% seguro | 📥 Descarga inmediata
              </div>

              <p className="text-xs text-brand-gray italic text-center leading-relaxed" data-id="element-134" data-mp="2xb3eh1vomrji">
                ⚕️ El contenido es informativo y educativo. No reemplaza
                consejo, diagnóstico ni tratamiento médico profesional. Consulta
                siempre a tu médico ante cualquier duda.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}